import React, { useState, useContext } from "react";
import "bootstrap/dist/css/bootstrap.css";
import AccessTimeIcon from "../../../assets/icons/clock-icon.svg";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AvTimerOutlinedIcon from "@mui/icons-material/AvTimerOutlined";
import NotCompleted from "../modals/NotCompleted";
import SessionComplete from "../modals/SessionCompleted";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../context";
const MarkedSessions = ({
  session,
  status,
  markedSessions,
  openModal,
  handleOpenModal,
  handleCloseModal,
  openModal1,
  handleOpenModal1,
  handleCloseModal1,
  loading,
}) => {
  const [currPage, setcurrPage] = useState(1);
  const [appointmentId, setAppointmentId] = useState("");
  const cards = 5;
  const lastIndex = currPage * cards;
  const firstIndex = lastIndex - cards;
  const navigate = useNavigate();
  const { expertDashboardData, setExpertDashboardData } =
    useContext(AppContext);
  const validateSession = (data) => {
    if (data?.session_status === "Not Completed") {
      handleOpenModal1();
    } else {
      handleOpenModal();
    }
    setAppointmentId(data?.appointment_id);
  };
  const searchBarParams = new URLSearchParams(window.location.search);
  const session_status = searchBarParams.get("completed_flag");
  return (
    <div style={{ backgroundColor: "white" }}>
      <p
        style={{
          color: "black",
          fontSize: "16px",
          fontFamily: "Inter",
          fontStyle: "normal",
          fontWeight: 600,
          marginLeft: "40px",
          paddingTop: "30px",
        }}
      >
        {session == "completed"
          ? "Completed Sessions"
          : session === "all"
          ? "Marked Sessions"
          : "Not Completed Sessions"}
      </p>

      <div className="d-flex flex-wrap px-3 mt-3 mx-3 custom-font">
        {!loading &&
          markedSessions &&
          markedSessions.length > 0 &&
          markedSessions?.map((data, index) => (
            <div key={index} className="col-md-6 col-lg-4 col-xl-3 mb-4 px-2">
              <div
                className="card h-100 shadow-sm"
                style={{
                  borderRadius: "12px",
                  border: "1px solid #E5E7EB",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div className="card-body p-4">
                  {/* Header with profile and status */}
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          data.client_pofile_picture ||
                          "/assets/default-profile.jpg"
                        }
                        alt="User"
                        className="rounded-circle"
                        style={{
                          width: "48px",
                          height: "48px",
                          objectFit: "cover",
                          border: "2px solid #F3F4F6",
                        }}
                      />
                      <div className="ms-3">
                        <h6
                          className="mb-1"
                          style={{
                            fontFamily: "Inter",
                            fontWeight: 600,
                            fontSize: "16px",
                            color: "#1F2937",
                            lineHeight: "1.2",
                          }}
                        >
                          {data.client_name}
                        </h6>
                        <p
                          className="mb-0"
                          style={{
                            fontFamily: "Inter",
                            fontWeight: 400,
                            fontSize: "12px",
                            color: "#6B7280",
                          }}
                        >
                          Follow-up
                          <span
                            className="badge"
                            style={{
                              backgroundColor:
                                data.session_status !== "Not Completed"
                                  ? "#DCFAE6"
                                  : "#FEE4E2",
                              color:
                                data.session_status !== "Not Completed"
                                  ? "#079455"
                                  : "#D92D20",
                              fontFamily: "Inter",
                              fontWeight: 500,
                              fontSize: "11px",
                              padding: "4px 8px",
                              borderRadius: "60px",
                              marginLeft: "8px",
                            }}
                          >
                            {data.session_status === "Not Completed"
                              ? "Not Completed"
                              : "Completed"}
                          </span>
                        </p>
                        {/* Status Badge */}
                      </div>
                    </div>
                  </div>

                  {/* Date and Time */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                      <CalendarMonthIcon
                        style={{
                          color: "#73589b",
                          height: "22px",
                          marginRight: "6px",
                        }}
                      />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "13px",
                          color: "#374151",
                        }}
                      >
                        {data.start_date}
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <AvTimerOutlinedIcon 
                        style={{
                          color: "#73589b",
                          height: "22px",
                          marginRight: "6px",
                        }} 
                      />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "13px",
                          color: "#374151",
                        }}
                      >
                        {data.start_time}
                      </span>
                    </div>
                  </div>

                  {/* View Details Button */}
                  <div className="d-flex justify-content-center">
                    <button
                      className="btn d-flex align-items-center gap-2"
                      style={{
                        backgroundColor: "transparent",
                        border: "1px solid #D1D5DB",
                        borderRadius: "8px",
                        padding: "8px 16px",
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "13px",
                        color: "#374151",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        width: "100%",
                        justifyContent: "center",
                      }}
                      onClick={() => validateSession(data)}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#F9FAFB";
                        e.target.style.borderColor = "#9CA3AF";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.borderColor = "#D1D5DB";
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                          fill="currentColor"
                        />
                      </svg>
                      View Details
                    </button>
                  </div>

                  {/* Missed meeting indicator */}
                  {data?.incompleted_flag && (
                    <div
                      className="d-flex align-items-center gap-2 mt-3 pt-3"
                      style={{ borderTop: "1px solid #F3F4F6" }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor: "#EF4444",
                          flexShrink: 0,
                        }}
                      ></span>
                      <p
                        className="mb-0"
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 400,
                          fontSize: "12px",
                          color: "#EF4444",
                        }}
                      >
                        Missed meeting
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        <NotCompleted
          status={"read"}
          appointment_id={appointmentId}
          open={openModal1}
          handleClose={handleCloseModal1}
        />
        <SessionComplete
          status={"read"}
          appointment_id={appointmentId}
          open={openModal}
          handleClose={handleCloseModal}
        />
        {!loading && markedSessions && markedSessions.length === 0 && (
          <div className="NoDataAvailable">
            <img src="/assets/img/no-appointment.png" />
            <p>No Sessions Found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MarkedSessions;
